// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3357":"5792f0b5","4774":"9504fba1","6791":"70ee819d"}[chunkId] + ".chunk.css";
};